import React from 'react';
import { Button, HStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../../../../constants/cypressIds';
import { InsuredProfilePageDuskIds } from '../../../../../../constants/duskIds';

const SaveAndCloseButtons = ({ onSave, onClose, dataAnalyticsId = undefined, isDisabled = false }) => (
  <HStack
    justifyContent="center"
    mt="auto !important"
    position="relative"
    spacing={4}
  >
    <Button
      data-cy={CypressIds.insuredProfileCloseDetailsButton}
      dusk={InsuredProfilePageDuskIds.closeInsuredDetailsModal}
      variant="secondary"
      width="100px"
      onClick={onClose}
    >
      Close
    </Button>
    <Button
      data-analytics-id={dataAnalyticsId}
      data-cy={CypressIds.insuredProfileSaveDetailsButton}
      isDisabled={isDisabled}
      type="submit"
      variant="primary"
      width="100px"
      onClick={onSave}
    >
      Save
    </Button>
  </HStack>
);

SaveAndCloseButtons.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  dataAnalyticsId: PropTypes.string,
  isDisabled: PropTypes.bool
};

export default SaveAndCloseButtons;
